<div class="report-modal">

  <div class="popup-header d-flex justify-content-between align-items-center position-relative">
    <strong class="title position-absolute top-50 start-50 translate-middle text-center fs-6">
      {{ 'REPORT.NEW_REPORT' | translate }}
    </strong>
    <button type="button" class="btn-close ms-auto p-2" (click)="onCancel()"></button>
  </div>

  <div class="popup-content">

    <div class="input-container">
      <label class="input-label">{{ 'DEVICE.SITE' | translate }}<span class="text-danger"> * </span></label>
      <ng-select
        [items]="sites"
        bindLabel="nom"
        [(ngModel)]="selectedSite"
        (ngModelChange)="onSiteChange($event)"
        [clearable]="false"
        [placeholder]="'REPORT.SITE_NAME' | translate"
      ></ng-select>
    </div>

    <div class="input-container mt-3">
      <label class="input-label">{{ 'NAVIGATION.MEASUREMENT_POINT' | translate }}<span class="text-danger"> * </span></label>
      <ng-select
        [ngClass]="{ 'locked-control-point-select': lockControlPointsSelection }"
        [items]="controlPoints"
        bindLabel="name"
        [(ngModel)]="selectedControlPoints"
        [multiple]="true"
        [closeOnSelect]="false"
        [clearable]="!lockControlPointsSelection"
        [loading]="loadingControlPoints"
        [disabled]="lockControlPointsSelection || !selectedSite"
        [placeholder]="'REPORT.MEASUREMENT_POINT_NAME' | translate"
      ></ng-select>
    </div>

    <div class="input-container mt-3">
      <label class="input-label">{{ 'DEVICE.TITLE' | translate }}<span class="text-danger"> * </span></label>
      <ng-select
        [ngClass]="{ 'locked-device-select': lockDevicesSelection }"
        [items]="devices"
        bindLabel="serialNumber"
        [(ngModel)]="selectedDevices"
        [multiple]="true"
        [closeOnSelect]="false"
        [clearable]="!lockDevicesSelection"
        [disabled]="lockDevicesSelection || !selectedSite"
        [placeholder]="'DEVICE.LABEL' | translate"
      ></ng-select>
    </div>

    <div class="input-container mt-3">
      <label class="input-label">{{ 'REPORT.TYPE' | translate }}<span class="text-danger"> * </span></label>
      <ng-select
        [items]="reportTypes"
        [(ngModel)]="selectedType"
        [clearable]="false"
        [searchable]="false"
      ></ng-select>
    </div>

    <div class="input-container mt-3">
      <label class="input-label">{{ 'REPORT.START_DATE' | translate }}<span class="text-danger"> * </span></label>
      <input type="date" class="input-field" [(ngModel)]="startDate" required />
    </div>

    <div class="input-container mt-3">
      <label class="input-label">{{ 'REPORT.END_DATE' | translate }}<span class="text-danger"> * </span></label>
      <input type="date" class="input-field" [(ngModel)]="endDate" required />
    </div>

    <div *ngIf="formError" class="text-danger mt-2" style="font-size: 0.8rem; font-weight: 600;">
      {{ formError | translate }}
    </div>

  </div>

  <div class="popup-footer">
    <button class="secondary-button popup-secondary-button" (click)="onCancel()">{{ 'BUTTONS.CANCEL' | translate }}</button>
    <button class="primary-button popup-primary-button" (click)="onConfirm()" [disabled]="!isFormValid()">{{ 'BUTTONS.CONFIRM' | translate }}</button>
  </div>

</div>
